<!-- Language/Flag Selector - Commented out -->
<!-- <button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5">
    <i class="flag-icon flag-icon-{{selectedLanguage.icon}}"> </i>
</button>
<mat-menu #flags="matMenu" class="mymegamenu">
    <button mat-menu-item *ngFor="let lang of languages" (click)="changeLanguage(lang)">
        <i class="flag-icon flag-icon-{{lang.icon}} m-r-10"></i>
        <span>{{lang.language}}</span>
    </button>
</mat-menu> -->

<!-- ============================================================== -->
<!-- Notification - style you can find in header.scss - Commented out -->
<!-- ============================================================== -->
<!-- <button [matMenuTriggerFor]="notification" mat-icon-button class="m-r-5">
    <mat-icon>message</mat-icon>
    <div class="notify">
        <span class="heartbit"></span>
        <span class="point"></span>
    </div>
</button>
<mat-menu #notification="matMenu" class="mymegamenu">
    <div class="mailbox">
        <ul>
            <li>
                <div class="drop-title">Notifications</div>
            </li>
            <li>
                <div class="message-center">
                    <perfect-scrollbar [config]="config">
                        <a href="#" *ngFor="let notification of notifications">
                            <div class="round {{notification.round}}">
                                <i class="{{notification.icon}}"></i>
                            </div>
                            <div class="mail-content">
                                <h5>{{notification.title}}</h5>
                                <span class="mail-desc">{{notification.subject}}</span>
                                <span class="time">{{notification.time}}</span>
                            </div>
                        </a>

                    </perfect-scrollbar>
                </div>
            </li>

        </ul>
    </div>
</mat-menu> -->
<!-- ============================================================== -->
<!-- Email/Messages - style you can find in header.scss - Commented out -->
<!-- ============================================================== -->
<!-- <button [matMenuTriggerFor]="message" mat-icon-button class="m-r-5">
    <mat-icon>email</mat-icon>
    <div class="notify">
        <span class="heartbit"></span>
        <span class="point"></span>
    </div>
</button>
<mat-menu #message="matMenu" class="mymessage">
    <div class="mailbox">
        <ul>
            <li>
                <div class="drop-title">You have 4 new Mymessages</div>
            </li>
            <li>
                <div class="message-center">
                    <perfect-scrollbar [config]="config">
                        <a href="#" *ngFor="let mymessage of mymessages">
                            <div class="user-img">
                                <img src="{{mymessage.useravatar}}" alt="user" class="img-circle" width="40">
                                <span class="profile-status {{mymessage.status}} pull-right"></span>
                            </div>
                            <div class="mail-content">
                                <h5>{{mymessage.from}}</h5>
                                <span class="mail-desc">{{mymessage.subject}}</span>
                                <span class="time">{{mymessage.time}}</span>
                            </div>
                        </a>
                    </perfect-scrollbar>
                </div>
            </li>
        </ul>
    </div>
</mat-menu> -->
<!-- ============================================================== -->
<!-- Blockchain failure report (Excel download) -->
<!-- ============================================================== -->
<app-failure-report-download></app-failure-report-download>
<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->
<button [matMenuTriggerFor]="profile" mat-icon-button class="m-r-5" matTooltip="Profile" aria-label="Profile">
    <img *ngIf="hasUserPhoto" [src]="userProfilePhotoUrl" alt="user" class="profile-pic" (error)="onImageError()">
    <mat-icon *ngIf="!hasUserPhoto" class="default-profile-icon">account_circle</mat-icon>
</button>
<mat-menu #profile="matMenu" class="mymegamenu" xPosition="before" yPosition="below">
    <div class="user-profile-header" style="padding: 15px; border-bottom: 1px solid #e0e0e0;">
        <div style="display: flex; align-items: center; gap: 12px;">
            <img *ngIf="hasUserPhoto" [src]="userProfilePhotoUrl" alt="user" style="width: 50px; height: 50px; border-radius: 50%; object-fit: cover;" (error)="onImageError()">
            <mat-icon *ngIf="!hasUserPhoto" style="font-size: 50px; width: 50px; height: 50px; color: #9e9e9e;">account_circle</mat-icon>
            <div>
                <p style="margin: 0; font-weight: 600;">{{ userDisplayName }}</p>
                <p style="margin: 3px 0 0 0; font-size: 12px; color: #666;">{{ currentUser?.email || authService.getCurrentUser()?.email }}</p>
                <p style="margin: 3px 0 0 0; font-size: 11px; color: #1976d2; text-transform: capitalize;">{{ currentUser?.role || authService.getCurrentUser()?.role }}</p>
            </div>
        </div>
    </div>
    <button mat-menu-item (click)="goToProfile()">
        <mat-icon>account_circle</mat-icon> My Profile
    </button>
    <!-- <button mat-menu-item (click)="goToProfile()">
        <mat-icon>settings</mat-icon> Settings
    </button> -->
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon> Sign Out
    </button>
</mat-menu>